<template>
  <fragment v-if="isLoaded">
    <div>
      <div class="wraper">
        <div class="container-fluid mycontainer-fluid">
          <slot name="header"></slot>
          <div class="row myrow">
            <div class="col-xs-12 mycol header-title">
              <div class="col-xs-12 mycol">
                <div class="h-t-name pull-left">Заседания</div>
                <!--<div class="pull-right">
                  <a
                    target="_blank"
                    href="https://lkbe.frprf.ru/es_report/"
                    class="btn btn-success"
                    style="margin-right: 12px"
                    >Отчет по ЭС</a
                  >
                </div>-->
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mycontainer-fluid content content_table">
          <div class="wrapper-header">
            <form v-on:submit.prevent="fetchExpertise">
              <div class="row myrow project-filter filter-wrapper-stl">
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <Multiselect
                    label="NAME"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :limit="3"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="filter.expert_sovet_type"
                    :options="expertList"
                    :multiple="true"
                    placeholder="Тип заседания"
                  />
                </div>

                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <input
                    id="filter_number"
                    type="text"
                    class="filter-input-stl"
                    placeholder="Номер"
                    v-model="filter.number"
                  />
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <datepicker
                    v-model="filter.date"
                    :language="ru"
                    inputClass="filter-input-stl filter-input-datapicer"
                    placeholder="Дата"
                    :monday-first="true"
                  ></datepicker>
                </div>
                <div class="stl-df-ac" style="width: 394px;">
                  <div
                    class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                  >
                    <button
                      class="project-filter__butt-btn butt-new-style butt-new-style-reset stl-w-full"
                      @click="clearFilter"
                      type="button"
                    >
                      СБРОС
                    </button>
                  </div>
                  <div
                    class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                  >
                    <button
                      class="project-filter__butt-btn butt-new-style stl-w-full"
                      type="submit"
                      v-on:click="fetchExpertise"
                    >
                      Применить
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="table-responsive container-stl" v-if="!isExpsLoading">
            <table class="table table-hover table-striped table-new-style">
              <thead>
                <tr>
                  <th></th>
                  <th class="text-nowrap">
                    №
                    <a
                      v-on:click="setOrder('UF_NUMBER')"
                      class="sort"
                      v-bind:class="{
                        desc: sortColumn === 'UF_NUMBER' && sortOrder === 'DESC'
                      }"
                    ></a>
                  </th>
                  <!--<th class="text-nowrap">
                Дата отображения
                <a
                  v-on:click="setOrder('UF_DATE_VIEW')"
                  class="sort"
                  v-bind:class="{
                    desc:
                      sortColumn === 'UF_DATE_VIEW' && sortOrder === 'DESC'
                  }"
                ></a>
              </th>-->
                  <th class="text-nowrap">
                    Дата
                    <a
                      v-on:click="setOrder('UF_DATE_SOVET')"
                      class="sort"
                      v-bind:class="{
                        desc:
                          sortColumn === 'UF_DATE_SOVET' && sortOrder === 'DESC'
                      }"
                    ></a>
                  </th>
                  <th class="text-nowrap">
                    Тип
                    <a
                      v-on:click="setOrder('UF_TYPE_SOVET_ID')"
                      class="sort"
                      v-bind:class="{
                        desc:
                          sortColumn === 'UF_TYPE_SOVET_ID' &&
                          sortOrder === 'DESC'
                      }"
                    ></a>
                  </th>
                  <th class="text-nowrap">Количество вопросов</th>
                  <th class="text-nowrap">Количество готовых вопросов</th>
                  <th class="text-nowrap">Фактический состав</th>
                  <th class="text-nowrap">Фактически проголосовали</th>
                  <th
                    v-if="experts.IS_VIEW_COLUMN_POVESTKA"
                    class="text-nowrap"
                  >
                    Повестка заседания
                  </th>
                  <th
                    v-if="experts.IS_VIEW_COLUMN_PROTOKOL"
                    class="text-nowrap"
                  >
                    Протокол заседания
                  </th>
                  <th style="width: 20px;"></th>
                  <th class="th-delete-doc stl-w-90"></th>
                </tr>
              </thead>
              <tbody v-if="experts && experts.counts">
                <tr
                  class="new"
                  unselectable="on"
                  style="cursor: default"
                  v-for="project in experts.items"
                  v-bind:key="project.ID"
                >
                  <td>
                    <template v-if="project.IS_EDIT == 1">
                      <a
                        class="icon-ex-st-viewing"
                        v-if="project.UF_IS_BLOCK_SOVET == 0"
                        title="Заблокировать"
                        v-on:click="setBlock(project, 1)"
                      >
                      </a>
                      <a
                        class="icon-ex-st-blocked"
                        title="Разблокировать"
                        v-if="
                          project.UF_IS_BLOCK_SOVET == 1 ||
                            project.UF_IS_BLOCK_SOVET == 3
                        "
                        v-on:click="setBlock(project, 2)"
                      >
                      </a>
                      <a
                        class="icon-ex-st-unlock"
                        v-if="project.UF_IS_BLOCK_SOVET == 2"
                        title="Заблокировать"
                        v-on:click="setBlock(project, 1)"
                      >
                      </a>
                    </template>
                  </td>
                  <td>
                    <router-link
                      :to="{
                        name: 'EAList',
                        params: { id: project.ID }
                      }"
                      style="color: #337ab7"
                      >{{ project.UF_NUMBER }}
                    </router-link>
                  </td>
                  <!--<td>{{ project.UF_DATE_VIEW | dateFormat }}</td>-->
                  <td>{{ project.UF_DATE_SOVET | dateFormat }}</td>
                  <td>{{ project.UF_TYPE_SOVET_TEXT }}</td>
                  <td>{{ project.COUNT_ALL_QUESTION }}</td>
                  <td>{{ project.COUNT_READY_QUESTION }}</td>
                  <td>
                    <a
                      v-if="project.IS_COUNT_MEMBER_LINK == 1"
                      :href="'/experts/conference/' + project.ID"
                      style="color: #337ab7"
                    >
                      {{ project.COUNT_MEMBER }}
                    </a>
                    <span v-else>{{ project.COUNT_MEMBER }}</span>
                  </td>
                  <td>{{ project.COUNT_MEMBER_READY }}</td>

                  <td v-if="experts.IS_VIEW_COLUMN_POVESTKA">
                    <template
                      v-if="
                        project.UF_POVESTKA_FILE_ID > 0 &&
                          experts.IS_EDIT_COLUMN_POVESTKA == 1
                      "
                    >
                      <a
                        class="reestr-link-file"
                        href="javascript:void(0)"
                        @click="
                          sUploaderFilePovestkaProtokolSovet(
                            'povestka',
                            project,
                            'edit'
                          )
                        "
                      >
                        {{ project.UF_POVESTKA_FILE_ID_NAME }}
                      </a>
                    </template>
                    <template
                      v-else-if="
                        project.UF_POVESTKA_FILE_ID > 0 &&
                          experts.IS_EDIT_COLUMN_POVESTKA == 0
                      "
                    >
                      <a
                        class="reestr-link-file"
                        href="javascript:void(0)"
                        @click="openDoc(project.UF_POVESTKA_FILE_ID)"
                      >
                        {{ project.UF_POVESTKA_FILE_ID_NAME }}
                      </a>
                    </template>
                    <button
                      v-else-if="experts.IS_EDIT_COLUMN_POVESTKA == 1"
                      class="project-filter__butt-btn butt-new-style stl-w-full butt-new-style-small butt-new-style-small-reestr"
                      type="button"
                      @click="
                        sUploaderFilePovestkaProtokolSovet(
                          'povestka',
                          project,
                          'add'
                        )
                      "
                    >
                      Загрузить
                    </button>
                  </td>
                  <td v-if="experts.IS_VIEW_COLUMN_PROTOKOL">
                    <template
                      v-if="
                        project.UF_PROTOKOL_FILE_ID > 0 &&
                          experts.IS_EDIT_COLUMN_PROTOKOL == 1
                      "
                    >
                      <a
                        class="reestr-link-file"
                        href="javascript:void(0)"
                        @click="
                          sUploaderFilePovestkaProtokolSovet(
                            'protokol',
                            project,
                            'edit'
                          )
                        "
                      >
                        {{ project.UF_PROTOKOL_FILE_ID_NAME }}
                      </a>
                    </template>
                    <template
                      v-else-if="
                        project.UF_PROTOKOL_FILE_ID > 0 &&
                          experts.IS_EDIT_COLUMN_PROTOKOL == 0
                      "
                    >
                      <a
                        class="reestr-link-file"
                        href="javascript:void(0)"
                        @click="openDoc(project.UF_PROTOKOL_FILE_ID)"
                      >
                        {{ project.UF_PROTOKOL_FILE_ID_NAME }}
                      </a>
                    </template>
                    <button
                      v-else-if="experts.IS_EDIT_COLUMN_PROTOKOL == 1"
                      class="project-filter__butt-btn butt-new-style stl-w-full butt-new-style-small butt-new-style-small-reestr"
                      type="button"
                      @click="
                        sUploaderFilePovestkaProtokolSovet(
                          'protokol',
                          project,
                          'add'
                        )
                      "
                    >
                      Загрузить
                    </button>
                  </td>

                  <td>
                    <a
                      v-if="project.UF_DIRECTUM_LINK_NO_TAG"
                      :href="project.UF_DIRECTUM_LINK_NO_TAG"
                      target="_blank"
                      class="icon-directim-link"
                    ></a>
                  </td>
                  <td>
                    <a
                      v-if="project.IS_EDIT == 1"
                      class="icon-item icon-edit-link"
                      @click="getItem(project)"
                    ></a>
                    <a
                      v-if="
                        project.IS_EDIT == 1 && project.COUNT_ALL_QUESTION == 0
                      "
                      @click="deleteItem(project)"
                      class="icon-item icon-delete-link"
                    ></a>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="10">Записи не найдены</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td
                    :colspan="
                      experts.IS_VIEW_COLUMN_POVESTKA &&
                      experts.IS_VIEW_COLUMN_PROTOKOL
                        ? 12
                        : 10
                    "
                  >
                    <div class="paging">
                      <div class="container-fluid">
                        <div class="row">
                          <div class="col-xs-6 mycol">
                            <Pagination
                              :pages="pages"
                              :currentPage.sync="currentPage"
                            ></Pagination>
                          </div>
                          <div class="col-xs-6 mycol">
                            <div class="pull-right page-total">
                              <span style="padding-right: 15px"
                                >Всего: {{ experts.counts }}</span
                              >
                              <span>Выводить по</span>
                              <span>
                                <select
                                  class="page-select"
                                  v-model="itemsPerPage"
                                >
                                  <option value="10">10</option>
                                  <option value="20">20</option>
                                  <option value="40">40</option>
                                  <option value="100">100</option>
                                  <option value="500">500</option>
                                </select>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div v-else>
            <h3>Загрузка...</h3>
          </div>

          <!-- Добавить заседание -->
          <div
            class="modal fade in"
            v-bind:class="{ show: showCreateNewProject }"
            tabindex="-1"
            role="dialog"
          >
            <form v-on:submit.prevent="onCreateProject">
              <div
                class="modal-dialog modal-dialog-datepicker-right modal-close-active modal-new-style"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      v-on:click="showCreateNewProject = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Добавить заседание</h4>
                  </div>
                  <div class="modal-body">
                    <div
                      class="alert alert-danger"
                      v-show="addError !== ''"
                      role="alert"
                    >
                      {{ addError }}
                    </div>

                    <div class="form-group">
                      <label>Тип</label>
                      <Multiselect
                        label="NAME"
                        class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                        style="background-image: none;"
                        :limit="1"
                        :limitText="filterItemText"
                        track-by="ID"
                        v-model="newProjectAdd.UF_TYPE_SOVET_ID"
                        :options="expertList"
                        :multiple="false"
                        placeholder="Тип заседания"
                        @input="changeTypeSovet"
                      />
                    </div>
                    <div class="form-group">
                      <label>Номер</label>
                      <input
                        v-model="newProjectAdd.UF_NUMBER"
                        class="form-control"
                        placeholder="Введите номер"
                      />
                    </div>
                    <div class="form-group no-bot">
                      <div
                        class="container-col col-xs-12 col-md-12 col-lg-12 mycol"
                      >
                        <table>
                          <tr>
                            <td><label>Дата</label></td>
                            <td><label>Время</label></td>
                          </tr>
                          <tr>
                            <td style="padding-bottom: 10px;">
                              <datepicker
                                v-model="newProjectAdd.UF_DATE_SOVET"
                                :monday-first="true"
                                :language="ru"
                                input-class="form-control filter-input-datapicer form-control-data-inp"
                              />
                            </td>
                            <td style="padding-bottom: 10px;">
                              <VueTimepicker
                                v-model="newProjectAdd.UF_DATE_SOVET_TIME"
                                format="HH:mm"
                                placeholder="Время"
                                hour-label="ч"
                                minute-label="мин"
                                input-class="form-control filter-input-timepicer"
                              />
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <div
                      class="form-group"
                      v-if="experts && experts.memberUserList"
                    >
                      <label>Фактический состав</label>
                      <Multiselect
                        label="FIO_FULL"
                        class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                        style="min-height: 40px; height: auto; background-image: none;"
                        :limit="40"
                        :limitText="filterItemText"
                        track-by="ID"
                        v-model="newProjectAdd.UF_FACT_SOSTAV_ID"
                        :options="memberList"
                        :multiple="true"
                        placeholder="Фактический состав"
                      />
                    </div>
                    <div
                      class="form-group"
                      v-if="experts && experts.secretaryList"
                    >
                      <label>Секретари</label>
                      <Multiselect
                        label="FIO_FULL"
                        class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                        style="min-height: 40px; height: auto; background-image: none;"
                        :limit="40"
                        :limitText="filterItemText"
                        track-by="ID"
                        v-model="newProjectAdd.UF_SECRETARY_SOSTAV_ID"
                        :options="secretaryList"
                        :multiple="true"
                        placeholder="Секретари"
                      />
                    </div>
                    <div class="form-group">
                      <label>Место проведения</label>
                      <vue-editor
                        ref="editor"
                        v-model="newProjectAdd.UF_PLACE_OF_EVENT"
                        :editor-toolbar="toolbar"
                        class="editor-min50"
                      ></vue-editor>
                    </div>
                    <div class="form-group">
                      <label>Directum</label>
                      <input
                        v-model="newProjectAdd.UF_DIRECTUM_LINK"
                        class="form-control"
                        placeholder="Введите ссылку на Directum"
                      />
                      <!--                      <vue-editor-->
                      <!--                        ref="editor"-->
                      <!--                        v-model="newProjectAdd.UF_DIRECTUM_LINK"-->
                      <!--                        :editor-toolbar="toolbarLink"-->
                      <!--                        class="editor-min50"-->
                      <!--                      ></vue-editor>-->
                    </div>
                    <div
                      class="form-group"
                      v-if="
                        newProjectAdd.UF_TYPE_SOVET_ID &&
                          newProjectAdd.UF_TYPE_SOVET_ID.CODE &&
                          newProjectAdd.UF_TYPE_SOVET_ID.CODE == 'rgm'
                      "
                    >
                      <label>Номер протокола</label>
                      <input
                        v-model="newProjectAdd.UF_NUMBER_PROTOCOL"
                        class="form-control"
                        placeholder="Введите номер протокола"
                      />
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="butt-stl butt-black"
                      data-dismiss="modal"
                      v-on:click="showCreateNewProject = false"
                    >
                      Отмена
                    </button>
                    <button type="submit" class="butt-stl butt-blue">
                      Создать
                    </button>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
              <!-- /.modal-dialog -->
            </form>
          </div>
          <!-- /.modal -->
          <!-- // Добавить заседание -->

          <!-- Удалить заседание -->
          <div
            class="modal fade in"
            tabindex="-1"
            v-bind:class="{ show: showDialogDelete }"
            role="dialog"
          >
            <form>
              <div class="modal-dialog modal-new-style" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Удалить заседание</h4>
                  </div>
                  <div class="modal-body">
                    <div class="form-group">
                      <p>
                        Вы действительно хотите удалить заседание? Данное
                        действие невозможно будет восстановить.
                      </p>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="butt-stl butt-black"
                      data-dismiss="modal"
                      v-on:click="showDialogDelete = false"
                    >
                      отменить
                    </button>
                    <button
                      type="button"
                      v-on:click="deleteItemSend(itemTemp)"
                      class="butt-stl butt-red"
                    >
                      Удалить
                    </button>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
              <!-- /.modal-dialog -->
            </form>
          </div>
          <!-- /.modal -->
          <!-- Удалить заседание -->

          <!-- Блокировка изменений повестки ЭС-->
          <div
            class="modal fade in"
            v-bind:class="{ show: showDialogBlock }"
            tabindex="-1"
            role="dialog"
          >
            <form>
              <div class="modal-dialog modal-new-style" role="document">
                <div class="modal-content" style="min-width: 640px;">
                  <div class="modal-header">
                    <button type="button" class="close" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">
                      Блокировка изменений повестки заседания
                    </h4>
                  </div>
                  <div class="modal-body">
                    <div class="form-group">
                      <p
                        v-if="
                          itemTemp.UF_IS_BLOCK_SOVET == 0 ||
                            itemTemp.UF_IS_BLOCK_SOVET == 2
                        "
                      >
                        Блокировка изменений повестки возможна двумя
                        способами:<br /><br />

                        1. Полная блокировка изменений. В таком случае изменение
                        списка вопросов и списка документов по конкретному
                        вопросу станет невозможна.<br /><br />

                        2. Частичная блокировка изменений. В таком случае не
                        получится изменить список вопросов, но получится менять
                        набор документов в ранее добавленных вопросах"
                      </p>
                      <p v-else>
                        Вы действительно хотите разблокировать изменение
                        повестки заседания №&nbsp;{{ itemTemp.UF_NUMBER }}?
                        После нажатия кнопки “Разблокировать” станет доступна
                        возможность изменения повестки.
                      </p>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="butt-stl butt-stl-small  butt-red"
                      v-if="
                        itemTemp.UF_IS_BLOCK_SOVET == 0 ||
                          itemTemp.UF_IS_BLOCK_SOVET == 2
                      "
                      v-on:click="
                        showDialogBlock = false;
                        showDialogBlockDopPartial = true;
                      "
                    >
                      Заблокировать частично
                    </button>
                    <button
                      v-else
                      type="button"
                      class="butt-stl butt-stl-small  butt-red"
                      v-on:click="setBlockSend(itemTemp, itemIsBlockTemp)"
                    >
                      разблокировать
                    </button>

                    <button
                      type="button"
                      class="butt-stl butt-stl-small  butt-red"
                      v-if="
                        itemTemp.UF_IS_BLOCK_SOVET == 0 ||
                          itemTemp.UF_IS_BLOCK_SOVET == 2
                      "
                      v-on:click="
                        showDialogBlock = false;
                        showDialogBlockDopFull = true;
                      "
                    >
                      заблокировать полностью
                    </button>
                    <button
                      type="button"
                      class="butt-stl butt-stl-small  butt-black"
                      data-dismiss="modal"
                      v-on:click="showDialogBlock = false"
                    >
                      отменить
                    </button>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
              <!-- /.modal-dialog -->
            </form>
          </div>
          <!-- /.modal -->
          <!-- Блокировка изменений повестки ЭС-->

          <!-- дополнительный вопрос - полная блокировка ЭС -->
          <div
            class="modal fade in"
            v-bind:class="{ show: showDialogBlockDopFull }"
            tabindex="-1"
            role="dialog"
          >
            <form>
              <div class="modal-dialog modal-new-style" role="document">
                <div class="modal-content" style="min-width: 640px;">
                  <div class="modal-header">
                    <button type="button" class="close" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">
                      Блокировка изменений повестки заседания
                    </h4>
                  </div>
                  <div class="modal-body">
                    <div class="form-group">
                      <p>
                        Вы действительно хотите полностью заблокировать
                        изменение повестки заседания № {{ itemTemp.UF_NUMBER }}?
                        После нажатия кнопки “Заблокировать” вся информация по
                        этой повестке (включая набор документов) станет
                        недоступной для редактирования.
                      </p>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="butt-stl butt-stl-small  butt-black"
                      data-dismiss="modal"
                      v-on:click="showDialogBlockDopFull = false"
                    >
                      отменить
                    </button>
                    <button
                      type="button"
                      class="butt-stl butt-stl-small  butt-red"
                      v-if="
                        itemTemp.UF_IS_BLOCK_SOVET == 0 ||
                          itemTemp.UF_IS_BLOCK_SOVET == 2
                      "
                      v-on:click="setBlockSend(itemTemp, itemIsBlockTemp)"
                    >
                      Заблокировать
                    </button>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
              <!-- /.modal-dialog -->
            </form>
          </div>
          <!-- end доп ЭС -->

          <!-- дополнительный вопрос - полная блокировка ЭС -->
          <div
            class="modal fade in"
            v-bind:class="{ show: showDialogBlockDopPartial }"
            tabindex="-1"
            role="dialog"
          >
            <form>
              <div class="modal-dialog modal-new-style" role="document">
                <div class="modal-content" style="min-width: 640px;">
                  <div class="modal-header">
                    <button type="button" class="close" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">
                      Блокировка изменений повестки заседания
                    </h4>
                  </div>
                  <div class="modal-body">
                    <div class="form-group">
                      <p>
                        Вы действительно хотите частично заблокировать изменение
                        повестки заседания № {{ itemTemp.UF_NUMBER }}? После
                        нажатия кнопки “Заблокировать” изменить список вопросов
                        не получится, однако, можно изменить набор документов.
                      </p>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="butt-stl butt-stl-small  butt-black"
                      data-dismiss="modal"
                      v-on:click="showDialogBlockDopPartial = false"
                    >
                      отменить
                    </button>
                    <button
                      type="button"
                      class="butt-stl butt-stl-small  butt-red"
                      v-if="
                        itemTemp.UF_IS_BLOCK_SOVET == 0 ||
                          itemTemp.UF_IS_BLOCK_SOVET == 2
                      "
                      v-on:click="setBlockSend(itemTemp, itemIsBlockTemp, 1)"
                    >
                      Заблокировать
                    </button>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
              <!-- /.modal-dialog -->
            </form>
          </div>
          <!-- end доп ЭС -->

          <!-- Редактирование заседания -->
          <div
            class="modal fade in"
            v-bind:class="{ show: showEditNewProject }"
            tabindex="-1"
            role="dialog"
          >
            <form v-on:submit.prevent="onEditProject">
              <div
                class="modal-dialog modal-dialog-datepicker-right modal-new-style modal-close-active"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      v-on:click="showEditNewProject = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Отредактировать заседание</h4>
                  </div>
                  <div class="modal-body">
                    <div
                      class="alert alert-danger"
                      v-show="addError !== ''"
                      role="alert"
                    >
                      {{ addError }}
                    </div>
                    <div class="form-group">
                      <label>Тип</label>
                      <Multiselect
                        label="NAME"
                        class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                        style="background-image: none;"
                        :limit="1"
                        :limitText="filterItemText"
                        track-by="ID"
                        v-model="newProject.UF_TYPE_SOVET_ID"
                        :options="expertList"
                        :multiple="false"
                        placeholder="Тип заседания"
                        @input="changeTypeSovet"
                      />
                    </div>
                    <div class="form-group">
                      <label>Номер</label>
                      <input
                        v-model="newProject.UF_NUMBER"
                        class="form-control"
                        placeholder="Введите номер"
                      />
                    </div>
                    <div class="form-group no-bot">
                      <div
                        class="container-col col-xs-12 col-md-12 col-lg-12 mycol"
                      >
                        <table>
                          <tr>
                            <td><label>Дата</label></td>
                            <td><label>Время</label></td>
                          </tr>
                          <tr>
                            <td style="padding-bottom: 10px;">
                              <datepicker
                                v-model="newProject.UF_DATE_SOVET"
                                :monday-first="true"
                                :language="ru"
                                input-class="form-control filter-input-datapicer form-control-data-inp"
                                placeholder=""
                              />
                            </td>
                            <td style="padding-bottom: 10px;">
                              <VueTimepicker
                                v-model="newProject.UF_DATE_SOVET_TIME"
                                format="HH:mm"
                                placeholder="Время"
                                hour-label="ч"
                                minute-label="мин"
                                input-class="form-control filter-input-timepicer"
                              />
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <div
                      class="form-group"
                      v-if="experts && experts.memberUserList"
                    >
                      <label>Фактический состав</label>
                      <Multiselect
                        label="FIO_FULL"
                        class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                        style="min-height: 40px; height: auto; background-image: none;"
                        :limit="40"
                        :limitText="filterItemText"
                        track-by="ID"
                        v-model="newProject.UF_FACT_SOSTAV_ID"
                        :options="memberList"
                        :multiple="true"
                        placeholder="Фактический состав"
                      />
                    </div>
                    <div
                      class="form-group"
                      v-if="experts && experts.secretaryList"
                    >
                      <label>Секретари</label>
                      <Multiselect
                        label="FIO_FULL"
                        class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                        style="min-height: 40px; height: auto; background-image: none;"
                        :limit="40"
                        :limitText="filterItemText"
                        track-by="ID"
                        v-model="newProject.UF_SECRETARY_SOSTAV_ID"
                        :options="secretaryList"
                        :multiple="true"
                        placeholder="Секретари"
                      />
                    </div>
                    <div class="form-group">
                      <label>Место проведения</label>
                      <vue-editor
                        ref="editor"
                        v-model="newProject.UF_PLACE_OF_EVENT"
                        :editor-toolbar="toolbar"
                        class="editor-min50"
                      ></vue-editor>
                    </div>
                    <div class="form-group">
                      <label>Directum</label>
                      <input
                        v-model="newProject.UF_DIRECTUM_LINK_NO_TAG"
                        class="form-control"
                        placeholder="Введите ссылку на Directum"
                      />
                      <!--                      <vue-editor-->
                      <!--                        ref="editor"-->
                      <!--                        v-model="newProject.UF_DIRECTUM_LINK_NO_TAG"-->
                      <!--                        :editor-toolbar="toolbarLink"-->
                      <!--                        class="editor-min50"-->
                      <!--                      ></vue-editor>-->
                    </div>
                    <div
                      class="form-group"
                      v-if="
                        newProject.UF_TYPE_SOVET_ID &&
                          newProject.UF_TYPE_SOVET_ID.CODE &&
                          newProject.UF_TYPE_SOVET_ID.CODE == 'rgm'
                      "
                    >
                      <label>Номер протокола</label>
                      <input
                        v-model="newProject.UF_NUMBER_PROTOCOL"
                        class="form-control"
                        placeholder="Введите номер протокола"
                      />
                    </div>
                    <!-- не стал удалять -->
                    <!--<div class="form-group">
                      <div style="width: 80%">
                        <div class="pull-left">
                          Создан: {{ newProject.UF_CREATED_BY }}
                        </div>
                        <div class="pull-right">
                          {{ newProject.UF_DATE_CREATE }}
                        </div>
                      </div>
                      <div class="clearfix"></div>
                      <div style="width: 80%">
                        <div class="pull-left">
                          Последнее изменение: {{ newProject.UF_MODIFIED_BY }}
                        </div>
                        <div class="pull-right">
                          {{ newProject.UF_TIMESTAMP_X }}
                        </div>
                      </div>
                      <div class="clearfix"></div>
                    </div>-->
                    <!-- не стал удалять -->
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="butt-stl butt-black"
                      data-dismiss="modal"
                      v-on:click="showEditNewProject = false"
                    >
                      Отмена
                    </button>
                    <button type="submit" class="butt-stl butt-blue">
                      Сохранить
                    </button>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
              <!-- /.modal-dialog -->
            </form>
          </div>
          <!-- /.modal -->
          <!-- Редактирование заседания -->
        </div>

        <!-- ЗАГРУЗКА ФАЙЛА Повестки и протокола заседания -->
        <div
          class="modal fade in"
          :class="{ show: showUploaderPovestkaProtokolSovetFile }"
          tabindex="-1"
          role="dialog"
        >
          <form action="#" @submit.prevent="submit" style="padding-right: 20px">
            <div
              role="document"
              class="modal-dialog modal-new-style modal-close-active"
            >
              <div class="modal-content">
                <div class="modal-header">
                  <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    data-dismiss="modal"
                    @click="
                      showUploaderPovestkaProtokolSovetFile = !showUploaderPovestkaProtokolSovetFile
                    "
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">
                    <template v-if="typeFile == 'povestka'"
                      >Повестка заседания
                    </template>
                    <template v-else-if="typeFile == 'protokol'"
                      >Протокол заседания
                    </template>
                  </h4>
                </div>
                <div class="modal-body" style="margin-bottom: 0px;">
                  <div
                    class="form-group"
                    v-if="
                      (typeFile == 'povestka' &&
                        itemFileTemp.UF_POVESTKA_FILE_ID > 0) ||
                        (typeFile == 'protokol' &&
                          itemFileTemp.UF_PROTOKOL_FILE_ID > 0)
                    "
                  >
                    <div class="upload-file-area">
                      <label class="upload-file-area__label">
                        <span class="upload-file-area__text">
                          <i class="icon-item icon-img-upload"></i>
                          <a
                            href="javascript:void(0)"
                            @click="openDoc(itemFileTemp.UF_POVESTKA_FILE_ID)"
                            v-if="
                              typeFile == 'povestka' &&
                                itemFileTemp.UF_POVESTKA_FILE_ID > 0
                            "
                            v-text="itemFileTemp.UF_POVESTKA_FILE_ID_NAME"
                          ></a>

                          <a
                            href="javascript:void(0)"
                            @click="openDoc(itemFileTemp.UF_PROTOKOL_FILE_ID)"
                            v-if="
                              typeFile == 'protokol' &&
                                itemFileTemp.UF_PROTOKOL_FILE_ID > 0
                            "
                            v-text="itemFileTemp.UF_PROTOKOL_FILE_ID_NAME"
                          ></a>
                        </span>
                        <button
                          class="butt-stl butt-red upload-file-area__btn-remove"
                          type="button"
                          @click="sDeleteFilePovestkaProtokolDialog"
                        >
                          Удалить
                        </button>
                      </label>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="upload-file-area">
                      <input
                        class="upload-file-area__input"
                        type="file"
                        name="file"
                        id="inp-file-expert-doc"
                        ref="file"
                        @change="changeFilePovestkaProtokol"
                      />
                      <label
                        for="inp-file-expert-doc"
                        class="upload-file-area__label"
                        v-if="fileName"
                      >
                        <span class="upload-file-area__text">
                          <i class="icon-item icon-img-upload"></i>
                          <span v-text="fileName"></span>
                          <span v-text="fileName2"></span>
                        </span>

                        <button
                          v-if="fileName2"
                          class="butt-stl butt-red upload-file-area__btn-remove"
                          type="button"
                          @click="clearFilePovestkaProtokolSovet"
                        >
                          Очистить
                        </button>
                      </label>
                    </div>
                    <div class="alert alert-info">
                      Максимальный размер файла для загрузки - 100 Мб.
                    </div>

                    <div v-if="errorText" class="alert alert-danger">
                      {{ errorText }}
                    </div>
                    <div
                      v-for="err in errorArr"
                      class="alert alert-danger"
                      style="margin-top: 10px"
                    >
                      {{ err.TEXT }}
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="submit"
                    class="butt-stl butt-blue"
                    :disabled="uploadBlockButton"
                  >
                    Сохранить
                  </button>
                  <button
                    type="button"
                    data-dismiss="modal"
                    class="butt-stl butt-black"
                    @click="showUploaderPovestkaProtokolSovetFile = false"
                  >
                    Отмена
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- ЗАГРУЗКА ФАЙЛА Повестки заседания-->

        <!-- Удалить файл Повестки заседания -->
        <div
          class="modal fade in"
          tabindex="-1"
          v-bind:class="{ show: showDialogDeleteFilePovestkaProtokol }"
          role="dialog"
        >
          <form>
            <div class="modal-dialog modal-new-style" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">
                    Удалить файл
                    {{
                      typeFile == "povestka"
                        ? "повестки заседания"
                        : "протокола заседания"
                    }}?
                  </h4>
                </div>
                <div class="modal-body">
                  <div class="form-group">
                    <p>
                      Вы действительно хотите удалить файл
                      {{
                        typeFile == "povestka"
                          ? "повестки заседания"
                          : "протокола заседания"
                      }}? Данное действие невозможно будет отменить.
                    </p>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="butt-stl butt-black"
                    data-dismiss="modal"
                    v-on:click="showDialogDeleteFilePovestkaProtokol = false"
                  >
                    отменить
                  </button>
                  <button
                    type="button"
                    v-on:click="deleteFilePovestkaProtokol()"
                    class="butt-stl butt-red"
                  >
                    Удалить
                  </button>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
          </form>
        </div>
        <!-- /.modal -->
        <!-- Удалить файл Повестки заседания -->
      </div>
      <!-- wraper -->
    </div>
    <div class="footer footer-fix">
      <div class="container-fluid mycontainer-fluid">
        <div class="myfooter">
          <div class="myfooter-frp pull-left"></div>
          <div class="pull-right">
            <a
              class="butt-green   butt-stl"
              v-if="experts && experts.IS_EDIT == 1"
              style="margin-right: 12px;padding: 3px 12px"
              @click="showCreateEA"
              >Добавить</a
            >
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import Pagination from "@/components/Pagination";
import { mapGetters } from "vuex";
import {
  FETCH_DIRECTORIES,
  FETCH_EXPERTS_LIST,
  SET_IS_VIEW_ALL_EXPERTISE,
  SET_MAIN_MENU
} from "@/store/actions.type";
import { ExpertAdvice, ListService, ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Datepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { ru } from "vuejs-datepicker/dist/locale";
import Multiselect from "vue-multiselect";
import Import_plan from "../project/form/partial/import_plan.vue";

export default {
  title: "Заседания",
  components: {
    Import_plan,
    Multiselect,
    Pagination,
    Datepicker,
    VueTimepicker
  },
  data() {
    return {
      siteUrl: "",
      extendFilter: false,
      filter: {
        number: "",
        date: ""
      },
      itemsPerPage: 10,
      currentPage: 1,
      sortOrder: "",
      sortColumn: "",
      showCreateNewProject: false,
      showEditNewProject: false,
      showDialogBlock: false,
      showDialogBlockDopFull: false,
      showDialogBlockDopPartial: false,
      itemTemp: [],
      itemIsBlockTemp: 0,
      showDialogDelete: false,
      sp: {
        statuses: []
      },
      ru: ru,
      newProject: {
        UF_NUMBER: "",
        UF_DATE_SOVET: "",
        UF_FACT_SOSTAV_ID: [],
        UF_DATE_SOVET_TIME: {},
        UF_SECRETARY_SOSTAV_ID: [],
        UF_DIRECTUM_LINK: ""
      },
      newProjectAdd: {
        UF_NUMBER: "",
        UF_DATE_SOVET: "",
        UF_FACT_SOSTAV_ID: [],
        UF_DATE_SOVET_TIME: {},
        UF_NUMBER_PROTOCOL: "",
        UF_TYPE_SOVET_ID: {},
        UF_SECRETARY_SOSTAV_ID: [],
        UF_DIRECTUM_LINK: ""
      },
      addError: "",
      showUploaderPovestkaProtokolSovetFile: false,
      typeFile: "",
      fileName: "Файл не выбран",
      fileName2: "",
      errorArr: [],
      errorText: "",
      itemFileTemp: [],
      uploadBlockButton: false,
      showDialogDeleteFilePovestkaProtokol: false,
      toolbar: [
        //["bold", "italic", "underline", "strike"], // toggled buttons
        ["link", "clean"]
        //  ["clean"] // remove formatting button
      ],
      toolbarLink: [["link"]],
      isLoaded: false
    };
  },

  mounted() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");

    this.$store.dispatch(SET_MAIN_MENU, []);
    ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
      let navMainMenu = [];
      if (data.START_PAGE === "REESTR_PROJECTS") {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        /*if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }*/
        if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
          this.isLoaded = true;
        }
        if (data.IS_VIEW_VOTE_SOVETE_MODULE && data.IS_VIEW_VOTE_SOVETE_MENU) {
          navMainMenu.push({
            name: "Заседания",
            route: "Conference"
          });
        }
        /*if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }
        navMainMenu.push({
          name: "Запросы",
          route: "Requests"
        });*/
      } else {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        /*if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }*/
        if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });


          if (data.IS_VIEW_REQUEST_MODULE) {
            navMainMenu.push({
              name: "Запросы",
              route: "Requests"
            });
          }

          this.isLoaded = true;
        }else if (data.IS_VIEW_VOTE_SOVETE_MODULE && data.IS_VIEW_VOTE_SOVETE_MENU) {
          navMainMenu.push({
            name: "Заседания",
            route: "Conference"
          });
        }
        /*if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }
        navMainMenu.push({
          name: "Запросы",
          route: "Requests"
        });*/
      }
      this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
      this.$store.dispatch(
        SET_IS_VIEW_ALL_EXPERTISE,
        data.IS_VIEW_ALL_EXPERTISE
      );
    });

    this.$store.dispatch(FETCH_DIRECTORIES, ["status", "program_fin_support"]);
    this.fetchExpertise();
  },

  computed: {
    ...mapGetters([
      "experts",
      "userProjectProgrammes",
      "addProjectError",
      "isExpsLoading",
      "currentUser",
      "directory",
      "DProgramFinSupport",
      "currentUser"
    ]),
    listConfig() {
      const q = {
        page: this.currentPage,
        limit: this.itemsPerPage,
        filter: {}
      };
      if (this.sortColumn !== "") {
        let sort = {
          column: "",
          order: ""
        };
        sort.column = this.sortColumn;
        sort.order = this.sortOrder;
        q.sort = sort;
      }
      if (this.filter.number !== "") {
        q.filter.UF_NUMBER = this.filter.number;
      }
      if (this.filter.date !== "") {
        q.filter.UF_DATE_SOVET = this.filter.date;
      }

      if (this.filter.expert_sovet_type !== "") {
        q.filter.UF_TYPE_SOVET_ID = this.filter.expert_sovet_type;
      }

      return q;
    },
    pages() {
      if (
        this.isExpsLoading ||
        !this.experts.counts ||
        this.experts.counts <= this.itemsPerPage
      ) {
        return [];
      }
      return [
        ...Array(Math.ceil(this.experts.counts / this.itemsPerPage)).keys()
      ].map(e => e + 1);
    },
    expertList() {
      let ret = [];
      let f = JSON.stringify(this.directory.sp_expert_sovet_type);
      ret = JSON.parse(f);

     //#98435
      let ret2 = [];
      if (this.currentUser.ACTIVE_ROLE_CODE == 'admin'){
        ret2 = ret;
      }else{
        ret.forEach(function(r) {
          if (r.CODE !== 'rgc'){
            ret2.push(r);
          }
        });
      }



      return ret2;
    },
    memberList() {
      let ret = [];
      if (this.experts && this.experts.memberUserList) {
        ret = this.experts.memberUserList;
      }
      return ret;
    },
    secretaryList() {
      let ret = [];
      if (this.experts && this.experts.secretaryList) {
        ret = this.experts.secretaryList;
      }
      return ret;
    }
  },

  watch: {
    currentPage(newValue) {
      this.listConfig.page = newValue;
      this.fetchExpertise();
    },
    itemsPerPage(newValue) {
      this.listConfig.limit = newValue;
      this.fetchExpertise();
    }
  },

  methods: {
    getPTypeId(id) {
      let t = this.directory.program_fin_support.filter(c => c.ID === id);
      if (t && t.length > 0) {
        return t[0].NAME;
      }
      return "";
    },
    setOrder(column) {
      if (this.sortColumn !== column) {
        this.sortOrder = "ASC";
      } else {
        if (this.sortOrder === "DESC") {
          this.sortOrder = "ASC";
        } else {
          this.sortOrder = "DESC";
        }
      }
      this.sortColumn = column;
      this.fetchExpertise();
    },
    setBlock(item, isBlock) {
      this.showDialogBlock = true;
      this.itemTemp = item;
      this.itemIsBlockTemp = isBlock;
    },
    setBlockSend(item, isBlock, isPartial = false) {
      ExpertAdvice.setBlockPlanExpertAdvice(item.ID, {
        UF_IS_BLOCK_SOVET: isPartial ? 3 : isBlock
      })
        .then(({ data }) => {
          if (data.errorArr.length) {
            this.$toasted.show(data.errorAr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            this.showDialogBlock = false;
            this.showDialogBlockDopPartial = false;
            this.showDialogBlockDopFull = false;
            this.fetchExpertise();
          }
        }, this)
        .catch(() => {
          this.addError = this.addProjectError;
        });
    },
    clearFilter() {
      this.filter = {
        status: "",
        name: "",
        program: "",
        number: "",
        org_name: "",
        archive: ""
      };
      this.fetchExpertise();
    },
    fetchExpertise() {
      this.$store.dispatch(FETCH_EXPERTS_LIST, this.listConfig).then(() => {
      }).catch( error => {
        if (error.message.includes("HttpCode:403")) {
          this.$router.push({ name: "ForbiddenPage403" });
        }
        if (error.message.includes("HttpCode:404")) {
          this.$router.push({ name: "NotFoundPage404" });
        }
      });
      this.$store.dispatch(FETCH_DIRECTORIES, [
        "regions",
        "program_fin_support",
        "status_expertise",
        "sp_expert_sovet_type"
      ]);
    },
    deleteItem(item) {
      this.showDialogDelete = true;
      this.itemTemp = item;
    },
    deleteItemSend(item) {
      ExpertAdvice.deletePlanExpertAdvice(item.ID)
        .then(({ data }) => {
          if (data.errorAr.length) {
            this.$toasted.show(data.errorAr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            this.showDialogDelete = false;
            this.fetchExpertise();
            this.$toasted.show("Заседание успешно удалено", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
          }
        }, this)
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    getItem(item) {
      ExpertAdvice.getItem(item.ID)
        .then(({ data }) => {
          this.showEditNewProject = true;

          this.newProject = data;
          this.newProject.UF_DATE_SOVET = item.UF_DATE_SOVET;
          this.newProject.UF_NUMBER_PROTOCOL = item.UF_NUMBER_PROTOCOL;
          this.newProject.UF_TYPE_SOVET_ID = data.UF_TYPE_SOVET_ID_OBJECT;
          this.newProject.UF_FACT_SOSTAV_ID = data.UF_FACT_SOSTAV_ID_OBJECT;
          this.newProject.UF_SECRETARY_SOSTAV_ID =
            data.UF_SECRETARY_SOSTAV_ID_OBJECT;
          this.newProject.UF_DATE_SOVET_TIME.HH = data.UF_DATE_SOVET_TIME[
            "HH"
          ].trim();
          this.newProject.UF_DATE_SOVET_TIME.mm = data.UF_DATE_SOVET_TIME[
            "mm"
          ].trim();
        }, this)
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    onCreateProject() {
      ExpertAdvice.addPlanExpertAdvice(this.newProjectAdd)
        .then(({ data }) => {
          if (data.error) {
            // this.$toasted.show(data.errorArr[0].TEXT, {
            //   theme: "red",
            //   position: "bottom-right",
            //   duration: 3500
            // });
            //
            this.addError = "";
            data.errorArr.forEach(function(text) {
              this.addError = text.TEXT + "\n";
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          } else {
            this.fetchExpertise();
            this.showCreateNewProject = false;
            this.newProject = {};
          }
        }, this)
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    onEditProject() {
      ExpertAdvice.editPlanExpertAdvice(this.newProject.ID, this.newProject)
        .then(data => {
          if (data.data.error) {
            this.addError = "";
            data.data.errorArr.forEach(function(text) {
              this.addError = text.TEXT + "\n";
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          } else {
            this.fetchExpertise();
            this.showEditNewProject = false;
            this.newProject = {};
          }
        }, this)
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    showCreateEA() {
      this.newProject = {};
      this.showCreateNewProject = true;
    },
    filterItemText(count) {
      console.log(count);
      return ``;
    },
    changeTypeSovet() {
      this.newProjectAdd.UF_FACT_SOSTAV_ID = this.experts.memberListByType[
        this.newProjectAdd.UF_TYPE_SOVET_ID.CODE
      ];

      this.newProjectAdd.UF_SECRETARY_SOSTAV_ID = this.experts.secretaryListByType[
        this.newProjectAdd.UF_TYPE_SOVET_ID.CODE
      ];

      if (this.newProjectAdd.UF_TYPE_SOVET_ID.CODE != "rgm") {
        this.newProjectAdd.UF_NUMBER_PROTOCOL = "";
      }

      if (this.newProjectAdd.UF_TYPE_SOVET_ID.CODE == "rgc") {
        this.newProjectAdd.UF_SECRETARY_SOSTAV_ID = {'ID':this.currentUser.ID, 'FIO_FULL': this.currentUser.NAME};
      }

      console.log(this.newProjectAdd.UF_SECRETARY_SOSTAV_ID);
    },
    sUploaderFilePovestkaProtokolSovet(type, project, mode) {
      this.showUploaderPovestkaProtokolSovetFile = !this
        .showUploaderPovestkaProtokolSovetFile;
      this.uploadBlockButton = false;
      this.typeIndex = -1;
      this.docName = "";
      this.file = "";
      this.fileName =
        mode == "add" ? "Файл не выбран" : "Обновить: файл не выбран";
      this.fileName2 = "";
      this.errorArr = [];
      this.errorText = "";
      this.typeFile = type;
      this.itemFileTemp = project;
    },
    clearFilePovestkaProtokolSovet() {
      this.typeIndex = -1;
      this.docName = "";
      this.file = "";
      this.fileName = "Файл не выбран";
      this.fileName2 = "";
      this.errorArr = [];
      this.errorText = "";
    },
    changeFilePovestkaProtokol() {
      let reader = new FileReader();
      (this.errorText = ""), reader.readAsDataURL(this.$refs.file.files[0]);
      reader.onload = () => {
        let file = this.$refs.file.files[0];
        if (file.size < 1024 * 1024 * 100) {
          let header = ";base64,";
          let fileData = reader.result;

          this.fileBase64 = fileData.substr(
            fileData.indexOf(header) + header.length
          );
        } else {
          this.errorText =
            "Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 100 Мб";
        }
      };
      this.fileName = this.$refs.file.files[0].name;
      this.fileName2 = this.fileName;
      this.fileName = "    ";
    },
    submit() {
      this.uploadBlockButton = true; //блокировка кнопки
      if (typeof this.$refs.file.files[0] === "undefined") {
        return false;
      }

      let formData = new FormData();
      formData.append("TYPE_FILE", this.typeFile);
      formData.append("FILE", this.$refs.file.files[0]);

      ExpertAdvice.saveFileProtokolPovestkaSovet(
        this.itemFileTemp.ID,
        formData,
        this.fileForm
      ).then(response => {
        this.uploadBlockButton = false;
        if (!response.data.error) {
          this.fetchExpertise();
          this.showUploaderPovestkaProtokolSovetFile = false;
          this.$toasted.show("Файл успешно загружен", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.errorArr = response.data.errorArr;
          this.uploadBlockButton = false;
        }
      }, this);
      return false;
    },
    sDeleteFilePovestkaProtokolDialog() {
      this.showDialogDeleteFilePovestkaProtokol = !this
        .showDialogDeleteFilePovestkaProtokol;
    },
    deleteFilePovestkaProtokol() {
      ExpertAdvice.deleteFilePovestkaProtokol(
        this.itemFileTemp.ID,
        this.typeFile
      ).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.fetchExpertise();
          this.$toasted.show("Файл успешно удален", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });

          this.showDialogDeleteFilePovestkaProtokol = false;
          this.showUploaderPovestkaProtokolSovetFile = false;
        }
      }, this);
    },
    openDoc(id) {
      ExpertAdvice.getLinkByFileAdvise(id).then(({ data }) => {
        window.open(
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
          "_blank"
        );
      });
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
};
</script>
